<template>
  <div>
    <dara-header size="sm">
      <router-link :to="MY_SPACE_URL.ranking.path">
        {{ $t('featured-users') }}
      </router-link>
    </dara-header>
    <dara-user-resume v-if="bestWriter" ref="bestWriter" :user="bestWriter" @reloadUser="updateFeaturedUsers" />
    <dara-user-resume v-if="topWriter" ref="topWriter" :user="topWriter" @reloadUser="updateFeaturedUsers" />
    <dara-user-resume v-if="topReader" ref="topReader" :user="topReader" @reloadUser="updateFeaturedUsers" />
    <dara-invisible v-if="emptyFeatureUsers">
      <dara-p color="info">( {{ $t('empty-featured-users') }} )</dara-p>
    </dara-invisible>
  </div>
</template>

<script>
import { fetchUsers, fetchBestWriters, fetchTopReaders, fetchTopWriters } from '@/modules/user/user.service';
import { toastError } from '@/services/toastService';
import { translate } from '@/services/translate.service';
import { MY_SPACE_URL } from '@/modules/my-space/my-space.constants';

import DaraUserResume from '@/modules/user/components/UserResume.vue';

export default {
  name: 'DaraHomeTopWriters',
  components: {
    DaraUserResume,
  },
  data() {
    return {
      bestWriter: null,
      topWriter: null,
      topReader: null,
      users: null,
      pagination: {
        page: 1,
        limit: 5,
      },
      MY_SPACE_URL,
    };
  },
  computed: {
    emptyFeatureUsers() {
      return !this.bestWriter && !this.topWriter && !this.topReader;
    },
  },
  mounted() {
    this.fetchUsers();
  },
  methods: {
    fetchUsers() {
      fetchUsers(this.pagination)
        .then(data => {
          this.users = data.users;
          if (data.total_company_users >= 3) this.fetchFeaturedUsers();
        })
        .catch(() => {
          toastError(`${translate('error-getting-users')}`);
        });
    },
    fetchFeaturedUsers() {
      this.fetchBestWriter();
      this.fetchTopWriter();
      this.fetchTopReader();
    },
    fetchBestWriter() {
      fetchBestWriters(1)
        .then(user => {
          if (user) {
            user.badge = 'best-writer';
            this.bestWriter = user;
          }
        })
        .catch(() => {
          toastError(`${translate('error-getting-best-writer')}`);
          this.bestWriter = null;
        });
    },
    fetchTopWriter() {
      fetchTopWriters(1)
        .then(user => {
          if (user) {
            user.badge = 'top-writer';
            this.topWriter = user;
          }
        })
        .catch(() => {
          toastError(`${translate('error-getting-top-writer')}`);
          this.topWriter = null;
        });
    },
    fetchTopReader() {
      fetchTopReaders(1)
        .then(user => {
          if (user) {
            user.badge = 'top-reader';
            this.topReader = user;
          }
        })
        .catch(() => {
          toastError(`${translate('error-getting-top-reader')}`);
          this.topReader = null;
        });
    },
    updateFeaturedUsers(user) {
      // re-rendering users after following one of them
      if (user.id === this.bestWriter.id) {
        this.bestWriter = null;
        this.fetchBestWriter();
      }
      if (user.id === this.topWriter.id) {
        this.topWriter = null;
        this.fetchTopWriter();
      }
      if (user.id === this.topReader.id) {
        this.topReader = null;
        this.fetchTopReader();
      }
    },
  },
};
</script>
